import axios from 'axios'
import config from '../../../config'
import Lists from '../../Lists'

let InsulinApi = {
  deleteInsulinTracking(progressId, trackingId) {
    return axios.delete(config.apiUrl + 'tracking/insulin/', {
      params: {
        progressId: progressId,
        trackingId: trackingId
      }
    })
  },
  getInsulinTrackingDetail(page, page_size) {
    return axios.get(config.apiUrl + 'tracking/insulin/detail/', {
      params: {
        page: page,
        page_size: page_size
      }
    })
  },
  getInsulinTypes() {
    return Lists.getInsulinTypesList()
  },
  getInsulinTrackingCard() {
    return axios.get(config.apiUrl + 'tracking/insulin/card/?requestFrom=web');
  },
  putInsulinTracking(model) {
    return axios.put(config.apiUrl + 'tracking/insulin/', model);
  },
  postInsulinTracking(model) {
    return axios.post(config.apiUrl + 'tracking/insulin/', model);
  }
};

export default InsulinApi



// WEBPACK FOOTER //
// ./src/api/Tracking/Insulin/index.js